import { FormattedMessage } from 'react-intl';
import { Schema } from 'src/utils/form';

export default Schema.object({
  nome: Schema.string().label(<FormattedMessage id="nome" />),
  responsaveis: Schema.string().label(''),
  idIntegracao: Schema.string().label(<FormattedMessage id="idIntegracao" />),
  tipoDocumentos: Schema.string().label(
    <FormattedMessage id="labelTipoDocumento" />
  ),
  //dataInicioVigencia: Schema.string().label(''),
  areas: Schema.string().label(''),
  areasSubordinadas: Schema.string().label(''),
  statusGeral: Schema.string().label(<FormattedMessage id="status" />),
  status: Schema.string().label(<FormattedMessage id="labelProximaVersao" />),
  situacaoDocumento: Schema.string().label(
    <FormattedMessage id="labelSituacao" />
  ),
  prazoParaVencimento: Schema.string().label(
    <FormattedMessage id="labelPrazoParaVencimento" />
  ),
  camposCustomizados: Schema.array(),
});
